/**
 * Loading skeletons for the record surface, one per region.
 *
 * - `RecordHeaderSkeleton` — the header slot's CONTENT while nothing is in
 *   the store (cold open, e.g. deep-link): a chip-row placeholder the same
 *   height as the real chip row, then an identity placeholder. The chrome
 *   renders the real close button beside it, so there is no placeholder for
 *   one here.
 * - `RecordBodySkeleton` — the body while the full fetch populates sections.
 *   Also used alone when the header can already render from a summary store
 *   entry, keeping the entity's identity continuous while the body loads.
 */

export function RecordHeaderSkeleton() {
  return (
    <div
      className='flex min-w-0 flex-col'
      aria-busy='true'
      data-testid='record-header-skeleton'
    >
      {/* Type chip row — min-h-9 matches RECORD_HEADER_ROW_CLASS. */}
      <div className='flex min-h-9 items-center'>
        <div className='h-4 w-32 bg-[var(--color-bg-tertiary)] rounded animate-pulse' />
      </div>
      {/* Identity */}
      <div className='flex items-center gap-3 pt-3 pb-1'>
        <div className='w-10 h-10 rounded-full bg-[var(--color-bg-tertiary)] animate-pulse shrink-0' />
        <div className='flex flex-col gap-1.5 flex-1'>
          <div className='h-5 w-40 bg-[var(--color-bg-tertiary)] rounded animate-pulse' />
          <div className='h-3.5 w-28 bg-[var(--color-bg-tertiary)] rounded animate-pulse' />
        </div>
      </div>
    </div>
  );
}

export function RecordBodySkeleton() {
  return (
    <div
      className='px-5 py-4 space-y-6'
      aria-busy='true'
      data-testid='record-body-skeleton'
    >
      {[1, 2, 3].map(i => (
        <div key={i} className='space-y-3'>
          <div className='h-5 w-24 bg-[var(--color-bg-tertiary)] rounded animate-pulse' />
          <div className='h-20 bg-[var(--color-bg-tertiary)] rounded-lg animate-pulse' />
        </div>
      ))}
    </div>
  );
}
